/*
 *  Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { Theme } from "@mui/material";

const coronaInfoStyle = {
  container: (theme: Theme) => ({
    [theme.breakpoints.only("xs")]: {
      textAlign: "center",
    },
  }),
  textContainer: (theme: Theme) => ({
    [theme.breakpoints.up("sm")]: {
      paddingLeft: "50px",
    },
  }),
  header: {
    color: "primary.main",
  },
  helpIcon: {
    maxWidth: { xs: "50%", sm: "100%" } ,
  },
};

export default coronaInfoStyle;
